<template>
  <el-input
    size="mini"
    v-if="!disabled"
    :value="value"
    @input="onInput"
    @change="onChange"
    :clearable="clearable"
    v-bind="$attrs"
  ></el-input>
  <span v-else>{{ value }}</span>
</template>
<script>
import EditMixin from "./edit-mixin";
export default {
  mixins: [EditMixin],
  props: {
    value: {
      type: String,
      required: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  methods: {
    onInput(val) {
      this.$emit("input", val);
    },
    onChange(val) {
      this.$emit("change", val);
    },
  },
};
</script>
